// extracted by mini-css-extract-plugin
export default {"ranger":"LogoAccordeon_ranger__hWpUW"};